import { IconDefinition, library } from '@fortawesome/fontawesome-svg-core'
import {
  faHouse,
  faCircleCheck,
  faPlug,
  faBadgeCheck,
  faUserGroup as faUserGroupfoLight,
  faClone,
  faEnvelopeOpen,
  faCalendar as faCalendarLight,
  faTriangleExclamation as faTriangleExclamationLight,
} from '@fortawesome/pro-light-svg-icons'
import {
  faLoader,
  faCircleCheck as faCircleCheckRegular,
  faCircleExclamation as faCircleExclamationRegular,
  faFileArrowDown as faFileArrowDownRegular,
  faAngleUp,
  faAngleDown,
  faPlus,
  faStar,
  faBox,
  faLaptop,
  faCar,
  faMobile,
  faShirt,
  faDesktop,
  faCamera,
  faMoneyBill,
  faCreditCard,
  faArrowDownToLine,
  faLaptopMobile,
  faCircleQuestion,
  faCheck,
  faPen,
  faEllipsis,
  faHandHoldingBox,
  faScrewdriverWrench,
  faLaptopSlash,
  faArrowUpRight,
  faArrowUpLeft,
  faClipboardListCheck,
  faPlug as faPlugRegular,
  faPlus as faPlusRegular,
  faTrash as faTrashRegular,
  faPen as faPenhRegular,
  faEllipsisVertical as faEllipsisVerticalhRegular,
  faCircleInfo as faCircleInfoRegular,
  faTrashCan as faTrashCanRegular,
  faTriangleExclamation as faTriangleExclamationRegular,
  faX as faXRegular,
  faXmark,
  faBolt as faBoltRegular,
  faFeather as faFeatherRegular,
  faPenToSquare as faPenToSquareRegular,
  faClock,
  faFileExport,
  faKey,
  faClockRotateLeft,
  faArrowUpRightFromSquare,
  faCircle,
  faBell,
  faHourglassStart,
  faGear,
  faBars,
  faPartyHorn,
  faCakeCandles,
  faUserPlus,
  faBullhorn,
  faClockRotateLeft as faClockRotateLeftRegular,
  faArrowRight as faArrowRightRegular,
  faCircleQuestion as faCircleQuestionRegular,
  faSlidersSimple as faSlidersSimpleRegular,
  faFloppyDisk as faFloppyDiskRegular,
  faArrowRightArrowLeft,
  faHeadphones,
  faLink,
  faEquals,
  faLinkSlash,
  faAlignCenter,
  faInputNumeric,
  faListUl,
  faPaperclip,
  faCircleMinus,
  faCalculatorSimple,
  faBallotCheck,
  faText,
  faBracketsCurly,
  faArrowDownToBracket as faArrowDownToBracketRegular,
  faTableLayout as faTableLayoutRegular,
  faCloudUpload as faCloudUploadRegular,
  faCircleArrowUp as faCircleArrowUpRegular,
  faUser as faUserRegular,
  faArrowUpToLine as faArrowUpToLineRegular,
  faPenLine,
  faBan,
  faBoxArchive as farBoxArchive,
  faCirclePlay,
  faChevronRight,
  faCopy,
  faCodeMerge,
  faBolt,
  faCodeBranch,
} from '@fortawesome/pro-regular-svg-icons'

import {
  faFileSpreadsheet,
  faFileArrowDown,
  faChevronDown,
  faGripDotsVertical,
  faChartMixed,
  faTableRows,
  faTableColumns,
  faPrint,
  faEye,
  faDownload,
  faClose,
  faPaperclipVertical,
  faDownToBracket,
  faBoxArchive,
  faHandHoldingBox as faHandHoldingBoxSolid,
  faHandsHoldingDiamond,
  faScrewdriverWrench as faScrewdriverWrenchSolid,
  faLaptopSlash as faLaptopSlashSolid,
  faEnvelopeOpenText,
  faLock,
  faRightFromBracket,
  faArrowRight,
  faArrowLeft,
  faChevronsRight,
  faEllipsis as faEllipsiSolid,
  faCheck as faCheckSolid,
  faXmark as faXmarkSolid,
  faArrowRightArrowLeft as faArrowRightArrowLeftSolid,
  faPlus as faPlusSolid,
  faCircleCheck as solidFaCircleCheck,
  faAngleRight,
  faChevronUp,
} from '@fortawesome/pro-solid-svg-icons'

import { faApple } from '@fortawesome/free-brands-svg-icons'

import { faSpinnerThird as faSpinnerThirdDuotone } from '@fortawesome/pro-duotone-svg-icons'

library.add(
  faHouse,
  faFileSpreadsheet,
  faFileArrowDown,
  faFileArrowDownRegular,
  faChevronDown,
  faChevronUp,
  faGripDotsVertical,
  faChartMixed,
  faTableRows,
  faTableColumns,
  faHeadphones,
  faBadgeCheck,
  faPrint,
  faEye,
  faDownload,
  faClose,
  faPaperclipVertical,
  faCircle,
  faDownToBracket,
  faLoader,
  faCircleCheck,
  faCircleCheckRegular,
  solidFaCircleCheck,
  faCircleExclamationRegular,
  faAngleUp,
  faAngleDown,
  faPlus,
  faStar,
  faBox,
  faLaptop,
  faCar,
  faMobile,
  faShirt,
  faDesktop,
  faCamera,
  faMoneyBill,
  faCreditCard,
  faArrowDownToLine,
  faLaptopMobile,
  faCircleQuestion,
  faCheck,
  faPen,
  faEllipsis,
  faHandHoldingBox,
  faHandHoldingBoxSolid,
  faHandsHoldingDiamond,
  faScrewdriverWrench,
  faScrewdriverWrenchSolid,
  faLaptopSlash,
  faLaptopSlashSolid,
  faBoxArchive,
  faArrowUpRight,
  faArrowUpLeft,
  faClipboardListCheck,
  faPlugRegular,
  faPlusRegular,
  faTrashRegular,
  faPenhRegular,
  faEllipsisVerticalhRegular,
  faCircleInfoRegular,
  faPlug,
  faUserGroupfoLight,
  faTrashCanRegular,
  faTriangleExclamationRegular,
  faXRegular,
  faBoltRegular,
  faEnvelopeOpenText,
  faLock,
  faXmark,
  faRightFromBracket,
  faFeatherRegular,
  faPenToSquareRegular,
  faPen,
  faArrowRight,
  faArrowLeft,
  faChevronsRight,
  faEllipsis,
  faClock,
  faXmark,
  faCircleQuestion,
  faFileExport,
  faKey,
  faClockRotateLeft,
  faArrowUpRightFromSquare,
  faBell,
  faCheck,
  faHourglassStart,
  faCheckSolid,
  faXmarkSolid,
  faEllipsiSolid,
  faGear,
  faBars,
  faApple as IconDefinition,
  faPartyHorn,
  faCakeCandles,
  faUserPlus,
  faBullhorn,
  faClockRotateLeftRegular,
  faArrowRightRegular,
  faCircleQuestionRegular,
  faSlidersSimpleRegular,
  faFloppyDiskRegular,
  faArrowRightArrowLeft,
  faArrowRightArrowLeftSolid,
  faPlusSolid,
  faClone,
  faHeadphones,
  faLink,
  faLinkSlash,
  faArrowRightRegular,
  faEquals,
  faEnvelopeOpen,
  faAlignCenter,
  faInputNumeric,
  faListUl,
  faPaperclip,
  faCircleMinus,
  faBallotCheck,
  faCalculatorSimple,
  faText,
  faBracketsCurly,
  faArrowDownToBracketRegular,
  faTableLayoutRegular,
  faCloudUploadRegular,
  faCalendarLight,
  faSpinnerThirdDuotone,
  faCircleArrowUpRegular,
  faUserRegular,
  faArrowUpToLineRegular,
  faTriangleExclamationLight,
  faAngleRight,
  faPenLine,
  faBan,
  farBoxArchive,
  faCirclePlay,
  faChevronRight,
  faCopy,
  faCodeBranch,
  faCodeMerge,
  faBolt,
)
